import { useEffect, useState, useCallback } from 'react';
/**
 * Takes a target ref that is defined in the page, ref needs to be the parent div/grid/box/etc. of the component.
 * Returns true/false whether or not the offsetWidth is greater or less than 775.
 * @param {ref} targetRef
 * @returns boolean
 */
const useDetectMobile = (targetRef) => {
    const [isDesktopView, setIsDesktopView] = useState(true);

    const ref = targetRef;

    useEffect(() => {
        const layout = ref?.current?.parentElement?.offsetWidth > 775 ? true : false;
        setIsDesktopView(layout);
    }, [ref]);

    const getLayoutMode = useCallback(() => {
        // layout mode state calls for either fullscreen desktop or mobile size
        return ref?.current?.parentElement?.offsetWidth > 775 ? true : false;
    }, [ref]);

    const onResize = useCallback(() => {
        // resizes layout whenever a resize event is detected
        setIsDesktopView(getLayoutMode());
    }, [getLayoutMode]);

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [onResize]);

    return isDesktopView;
};

export default useDetectMobile;
